import React from 'react';
import './Banner.scss';
export type Size = "half" | 'full' | 'oneTherd';
export type Overlay = 'lightOverlay' | 'darkOverlay' | 'darkerOverlay' | 'noOverlay';
export interface Props {
  bannerClass?: string,
  bannerId?: any,
  bannerSize: Size,
  bannerImage: any
  alterText: string,
  children?: any,
  bannerOverlay?: Overlay,
  style?: React.CSSProperties,
  childStyle?: React.CSSProperties
}
const Banner = ({
  bannerClass,
  bannerId,
  bannerSize,
  bannerImage,
  alterText,
  children,
  bannerOverlay ='noOverlay',
  style = {},
  childStyle = {}
}:Props) => {
  return (
    <div className={`mfg-banner${bannerClass ? (" "+ bannerClass) : '' }${bannerSize ? (" " + bannerSize) : ''}${bannerOverlay ? (" " + bannerOverlay) : ''}`} id={bannerId} style={style && style}>
      {bannerImage ? <img src={bannerImage} alt={alterText} /> : ""}
      <div className="bannerChildren" style={childStyle && childStyle}>{children}</div>
    </div>
  )
}

export default Banner;
